export default __webpack_public_path__ + "static/media/sketch09.1680e4a9.png";